import React, { useEffect } from 'react';

// Full-size photo shown on top of the page — no new tab. The close
// button sits on the photo itself (top-right corner); clicking outside the photo or
// pressing Esc also closes it.
const PhotoLightbox = ({ url, onClose, alt = 'Photo' }) => {
  useEffect(() => {
    if (!url) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [url, onClose]);

  if (!url) return null;
  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 1100, background: 'rgba(0,0,0,0.85)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ position: 'relative', display: 'inline-block', lineHeight: 0 }}
      >
        <img
          src={url}
          alt={alt}
          style={{ maxWidth: '92vw', maxHeight: '88vh', borderRadius: 8, display: 'block' }}
        />
        <button
          type="button"
          aria-label="Close photo"
          onClick={onClose}
          style={{
            position: 'absolute', top: 8, right: 8, width: 34, height: 34, borderRadius: '50%',
            border: 'none', background: 'rgba(0,0,0,0.65)', color: '#fff', fontSize: 18,
            lineHeight: '34px', textAlign: 'center', cursor: 'pointer', padding: 0,
          }}
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export default PhotoLightbox;
